import { useEffect } from "react";

interface SchemaOrgProps {
  data: Record<string, unknown>;
}

export default function SchemaOrg({ data }: SchemaOrgProps) {
  useEffect(() => {
    const scriptId = "schema-org-jsonld";
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.setAttribute("type", "application/ld+json");
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [data]);

  return null;
}